import React, {Component, Fragment} from "react";
import Page from "../../components/BaseComponents/Page/Page";
import {FaSolidIcon} from "../../components/FontAwesomeIcons";
import {ModuloGruppiAPI} from "../../api/ModuloGruppi/ModuloGruppiAPI";
import {ModuloServiziAPI} from "../../api/ModuloServizi/ModuloServiziAPI";
import FuxCursorPaginator from "../../components/BaseComponents/FuxCursorPaginator/FuxCursorPaginator";
import PropTypes from "prop-types";
import {GruppiWaitingListItem} from "./GruppiWaitingListItem";
import {ServiceWaitingListItem} from "./ServiceWaitingListItem";

export class WaitingListPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            groups: {
                hasItems: false,
                fetched: false,
            },
            services: {
                hasItems: false,
                fetched: false,
            },
        }
    }

    handleWaitingListItemRender = item => <GruppiWaitingListItem item={item}/>
    handleWaitingListPageRequest = cursor => ModuloGruppiAPI.WaitingList.pagination(cursor)
        .then(page => {
            this.setState(prevState => ({
                groups: {
                    ...prevState.groups,
                    hasItems: (page && Array.isArray(page.data) && page.data.length > 0) || page.total > 0,
                    fetched: true,
                }
            }));
            return page;
        })

    handleModuloServiziWaitingListItemRender = item => <ServiceWaitingListItem item={item}/>
    handleModuloServiziWaitingListPageRequest = cursor => ModuloServiziAPI.Books.waitingListPagination(cursor)
        .then(page => {
            this.setState(prevState => ({
                services: {
                    ...prevState.services,
                    hasItems: (page && Array.isArray(page.data) && page.data.length > 0) || page.total > 0,
                    fetched: true,
                }
            }));
            return page;
        })

    handleWaitingListEmptyPage = _ => null

    renderUnifiedEmptyState = _ => {
        if (this.state.groups.fetched && this.state.services.fetched && !this.state.groups.hasItems && !this.state.services.hasItems) {
            return <div className={"text-center"}>Non hai prenotazioni in attesa</div>;
        }
        return null;
    }

    render() {
        return (
            <Fragment>
                <Page
                    title={"Lista d'attesa"}
                    leftIcon={<FaSolidIcon name={"chevron-left"}/>}
                    onLeftIconClick={this.props.onDismiss}
                    active={true}
                >
                    <div className={"container mt-2"}>
                        <FuxCursorPaginator
                            onItemRender={this.handleWaitingListItemRender}
                            onPageRequest={this.handleWaitingListPageRequest}
                            onEmptyPage={this.handleWaitingListEmptyPage}
                        />
                        <div className={"mt-3"}>
                            <FuxCursorPaginator
                                onItemRender={this.handleModuloServiziWaitingListItemRender}
                                onPageRequest={this.handleModuloServiziWaitingListPageRequest}
                                onEmptyPage={this.handleWaitingListEmptyPage}
                            />
                        </div>
                        {this.renderUnifiedEmptyState()}
                    </div>
                </Page>
            </Fragment>
        )
    }
}

WaitingListPage.propTypes = {
    onDismiss: PropTypes.func,
}
